import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { ExcelDownloadTemplateType } from 'src/service/file-save.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FileUploadFor, FocusInputType, GeneralConfigType, KeyValueSet, LocalService, NumericConfig, SerialNumberGenerate, TriggeredEvent } from 'src/service/local.service';
import { ProductManagementService } from 'src/service/product-management.service';
import { RequestManagementService } from 'src/service/request-management.service';

@Component({
  selector: 'app-bulk-serial-numbers',
  templateUrl: './bulk-serial-numbers.component.html',
  styleUrls: ['./bulk-serial-numbers.component.scss']
})
export class BulkSerialNumbersComponent implements OnInit {
  FileUploadFor = FileUploadFor;
  lstSectionConfigKeys: string[] = ["serial_num"]; selectedType = '';
  productSerialNumberTypes: KeyValueSet[]; productId = ''; ctryCode = ''; purchaseEntryDetailId = '0';
  isShowDummyHeight = false; isExpiryAllowed = false; selectedDate = ''; config = {};
  maximumCount: number | null = null; prefix = ''; suffix = '';
  message: string = ''; isRedAlert: boolean = true;
  numericConfig: NumericConfig = { maxValue: 10000 } as NumericConfig;
  htmlId: string = ''; elementIds: any;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private productManagementService: ProductManagementService, private activeModal: NgbActiveModal, private requestManagementService: RequestManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      file: 'file' + this.htmlId,
      max_cnt: 'max_cnt' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onSetDateConfig();
    this.onLoad();
  }

  onLoad() {
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.ProductSerialNumberType).subscribe(result => {
      this.productSerialNumberTypes = result;
      this.selectedType = result[0].key;
    });
  }

  onAction(index) {
    switch (index) {
      case 1: {
        this.requestManagementService.downloadExcelTemplate(ExcelDownloadTemplateType.BulkSerialNumbers).subscribe(result => {
          if (result && result.length > 0) {
            this.localService.onDownloadFile(result, 'SerialNumbers');
          }
        });
      } break;
      case 2: {
        let element: HTMLButtonElement = document.getElementById(this.elementIds.file) as HTMLButtonElement;
        if (element) {
          element.click();
        }
      } break;
      case 3: {
        this.activeModal.close({ event: TriggeredEvent.Ok });
      } break;
    }
  }

  onSelectionChanged(value) {
    this.selectedType = value;
  }

  showHideDummyHeight(isShow: boolean) {
    this.isShowDummyHeight = isShow;
  }

  onSetDateConfig() {
    let today = this.localService.getDeviceDate();
    let date = today.getDate();
    let month = today.getMonth() + 1;
    this.selectedDate = (date.toString().length == 1 ? ('0' + date) : date) + '-' + (month.toString().length == 1 ? ('0' + month) : month) + '-' + today.getFullYear();
    this.config = { min: this.selectedDate, firstDayOfWeek: 'mo', showWeekNumbers: true, numOfMonthRows: 4, opens: 'left' };
  }

  onSave() {
    if (this.doCheck()) {
      let data: SerialNumberGenerate = {
        isExpiryAllowed: this.isExpiryAllowed,
        expiryDate: this.selectedDate,
        maximumCount: this.maximumCount,
        prefix: this.prefix,
        productId: this.productId,
        productSerialNumberType: parseInt(this.selectedType),
        suffix: this.suffix
      } as SerialNumberGenerate;
      this.productManagementService.generateSerialNumbers(data).subscribe(result => {
        this.localService.showInformationByStatus(result);
        this.onAction(3);
      });
    }
  }

  doCheck(): boolean {
    this.isRedAlert = true;
    let message = '';
    if (!this.maximumCount || this.maximumCount <= 0) {
      message = this.localService.languageContent.serial_num.need_max_cnt;
      this.localService.onFocusNextInput(this.elementIds.max_cnt, FocusInputType.TextBox);
    }
    this.message = message;
    return message == '';
  }

  onSerialEnter(e) {
    if (e.target.value && (e.target.value.toString().includes(' ') || e.target.value.toString().includes('\t'))) {
      e.target.value = e.target.value.replace(/ /gi, "").replace(/\t/gi, "");
      this.prefix = this.prefix.replace(/ /gi, "").replace(/\t/gi, "");
      this.suffix = this.suffix.replace(/ /gi, "").replace(/\t/gi, "");
    }
  }
}

